import DialogSurvey from "./DialogSurvey";

export default DialogSurvey;
